import request from '@/utils/request'
import axios from 'axios'
const hostmms = process.env.VUE_APP_MARKETING_API;
const hostums = process.env.VUE_APP_USER_API
//系统参数
export function webConfigsearchWebConfigInfoByConfCode(params) {
  return request({
    url: hostmms+'webConfig/searchWebConfigInfoByConfCode',
    method: 'get',
    params
  })
}
//前端页面查询通过配置参数代码查询系统参数信息
export function searchWebConfigInfoByConfCodes(params){
  return request.post(hostmms+`/webConfig/searchWebConfigInfoByConfCodes`,params)
}
//轮播图
export function bannersearchHomeBannerInfo(params) {
  return request({
    url: hostmms+'banner/searchHomeBannerInfo',
    method: 'get',
    params
  })
}
//活动
export function promotiongetgetManagePromotionInfo(params) {
  return request({
    url: hostmms+'promotion/getManagePromotionInfo',
    method: 'get',
    params
  })
}
//头部引流图
export function promotiongetWebPromotionInfo(params) {
  return request({
    url: hostmms+'promotion/getWebPromotionInfo',
    method: 'get',
    params
  })
}
//域名查询id
export function mappingqueryCorpIdByHostDomain(params) {
  return request({
    url: hostums+`ums-corp-mapping/queryCorpIdByHostDomain/${params}`,
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/companies.js